export default "/images/f5bc815a71f1fb2f8fb1006710c589dc.png";